import OTilesGridWithScroll from './o-tiles-grid-with-scroll';

export default OTilesGridWithScroll;